import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  fetchBlogDetails,
  fetchBlogpage,
  fetchServices,
} from "../Redux/slice/homeSlice";
import { Icon } from "@iconify/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../Api";


const InsightRap = styled.div`
  background: linear-gradient(0deg, #ffffff 0%, #f6f5f2 20%);
  padding-bottom: 50px;
  .upper-p {
    padding: 5px 15px;
    width: fit-content;
    height: 31px;
    display: flex;
    border: 1px solid #0000001a;
    color: #1a365d;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    font-weight: 500;
  }
  h1 {
    color: #1a365d;
    font-size: 52px;
    line-height: 57px;
    font-weight: 400;
    max-width: 700px;
    text-align: center;
  }
  h2 {
    color: #1a365d;
    font-size: 48px;
    line-height: 57px;
    font-weight: 400;
  }
  .detail-1 p {
    color: #1a365d;
    font-size: 11px;
    font-weight: 500;
  }
  .detail-1 img {
    width: 100%;
    height: auto;
    border-radius: 24px;
  }
  .detail-1 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-top: 160px;
    align-items: center;
  }
  .detail-2-all h5,
  .detail-2-all h6,
  .detail-2-all h4,
  .detail-2-all h3 {
    color: #1a365d !important;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    margin-top: 20px;
  }

  .detail-2-all h2 {
    color: #1a365d !important;
    font-size: 30px;
    font-weight: 500;
    line-height: 36px;
    margin: auto;
  }
  .detail-2-all p {
    color: #000000cc;
    font-size: 16px;
    margin-top: 20px;
    font-weight: 400;
    line-height: 22px;
  }
  .detail-2-all {
    max-width: 950px;
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    margin-top: 50px;
  }
  .detail-3 p {
    max-width: 688px;
    color: #000000cc;
    font-size: 20px;

    line-height: 30px;
    font-weight: 400;
    text-align: center;
  }
  .detail-3 h4 {
    color: #1a365d;
    font-size: 11px;
    font-weight: 500;
  }
  .detail-3 {
    background: #f6f5f2;
    width: 830px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    margin: auto;
    border-radius: 20px;
  }
  .detail-3-all {
    margin-top: 100px;
  }
  @media (max-width: 992px) {
    h1 {
      font-size: 45px;
    }
    .detail-3 {
      width: 100%;
    }
  }
  @media (max-width: 700px) {
    h1 {
      font-size: 32px;
      line-height: 40px;
    }
  }
  @media (max-width: 700px) {
  }
`;

const InsightsDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { blogDetail } = useSelector((state) => state.content);
  console.log(blogDetail);
  const details = blogDetail?.data?.blog;

  const date = new Date(details?.created_at);

  const options = { day: "2-digit", month: "long", year: "numeric" };

  const formattedDate = date.toLocaleDateString("en-US", options);
  useEffect(() => {
    dispatch(fetchBlogDetails(id));
  }, [dispatch]);

  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, [location.pathname]);

  const handledetails = (id) => {
    navigate(`/services/details/${id}`);
  };
  return (
    <InsightRap>
      <div className="detail-1 containers">
        <h6 className="upper-p">Insight</h6>
        <h1>
          {details?.title?.split(" ").map((word, index) => {
            const targetIndexes = [0, 1]; // 2nd word (index 1), 3rd word (index 2)
            return targetIndexes.includes(index) ? (
              <span key={index} style={{ color: "#0ea5e9" }}>
                {word}{" "}
              </span>
            ) : (
              word + " "
            );
          })}
        </h1>
        <p>{formattedDate}</p>
        <img
          src={`${API_URL}/${details?.banner}`}
          alt=""
        />
      </div>
      <div className="detail-2-all containers">
        <div
          className="detail-2 "
          dangerouslySetInnerHTML={{ __html: details?.description }}
        />
      </div>
      <div className="detail-3-all containers">
        <div className="detail-3">
          <p>{details?.quote}</p>
          <h4>{details?.quote_by}</h4>
        </div>
      </div>
    </InsightRap>
  );
};

export default InsightsDetails;
